import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import BottomNav from "@/components/BottomNav";
import { PersistContext } from "@/data/PersistProvider";
import Invite from "../Invite";
import Leader from "../Leader";
import Rule from "../Invite/Rule";
import MakeMoney from "../MakeMoney";
import FreeCash from "../FreeCash";
import Deposit from "./Deposit";
import Help from "./Help";
import Home from "./Home";
import Profile from "./Profile";
import Promotion from "./Promotion";
import Sidebar from "./Sidebar";
import Withdraw from "./Withdraw";
import style from "./style.less";
import { SendEvent } from "@/utils/Analytics";
import { FunctionalConfig } from "@/config";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const Index = () => {
  let location = useLocation();
  const query = useQuery();
  const agentRid = query.get("aid");
  const agentFrom = query.get("f");
  const inviteWheelInviter = query.get("invite_wheel_inviter");
  const phoenixClickId = query.get("click_id");
  let channel = query.get("c");
  if (!channel && location.pathname.startsWith("/c/")) {
    channel = location.pathname.substring(3);
  }
  const platform = query.get("p");
  const { getPersist, setPersist } = React.useContext(PersistContext);
  if (agentRid) {
    console.log("agentRid", agentRid);
    setPersist("agent_rid", agentRid);
  }
  if (agentFrom) {
    console.log("agentFrom", agentFrom);
    setPersist("agent_from", agentFrom);
  }
  if (inviteWheelInviter) {
    console.log("inviteWheelInviter", inviteWheelInviter);
    setPersist("invite_wheel_inviter", inviteWheelInviter);
  }
  if (platform) {
    setPersist("platform", platform);
    SendEvent("platform_view", { platform });
  } else {
    setPersist("platform", "h5");
    SendEvent("platform_view", { platform: "h5" });
  }
  console.log("channel", channel);
  if (channel) {
    setPersist("channel", channel);
    SendEvent("channel_view", { channel });
  } else {
    setPersist("channel", "");
  }
  if (phoenixClickId && !localStorage.getItem("attribution")) {
    localStorage.setItem("attribution", "ph");
    localStorage.setItem("ad_source", "ph");
    localStorage.setItem("attribution_id", phoenixClickId);
    // setPersist("channel", "px");
    // SendEvent("channel_view", { channel: "px" });
  }
  return (
    <div class={style.fill}>
      <div class={style.content}>
        <Switch location={location}>
          <Route path="/px" children={<Home />} />
          <Route path="/c" children={<Home />} />
          <Route path="/home" children={<Home />} />
          <Route path="/deposit" children={<Deposit />} />
          <Route path="/promotion" children={<Promotion />} />
          <Route path="/withdraw" children={<Withdraw />} />
          <Route path="/profile" children={<Profile />} />
          <Route path="/help" children={<Help />} />
          <Route path="/invite" children={<Invite />} />
          <Route path="/leader" children={<Leader />} />
          <Route path="/rule" children={<Rule />} />
          <Route path="/MakeMoney" children={<MakeMoney />} />
          <Route path="/FreeCash" children={<FreeCash />} />
          <Route path="/" children={<Home />} />
        </Switch>
      </div>
      {FunctionalConfig.indiaLeader || FunctionalConfig.pakistanLeader ? location.pathname !== "/invite" && <BottomNav /> : <BottomNav />}
    </div>
  );
};

export default Index;
